import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

const ProblemSolution = () => {
  const problems = [
    'Cotações manuais num mar de WhatsApp e planilhas.',
    'Base estreita de fornecedores — sempre os mesmos, sempre o mesmo preço.',
    'Horas para equalizar propostas com mix e condições diferentes.',
    'Sem histórico, sem trilha, sem governança.',
  ];

  const solutions = [
    'Base global mapeada pela I.A. a cada compra nova.',
    'Dezenas de fornecedores negociando em paralelo — em minutos.',
    'Painel comparativo item a item, gerado sozinho.',
    'Relatórios em PDF e Excel. Auditável de ponta a ponta.',
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div className="space-y-6">
            <span className="inline-block text-brand-azul/60 font-semibold text-sm uppercase tracking-wider">
              Hoje
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul leading-tight">
              Seu time de compras ainda vive no WhatsApp, planilha e ligação?
            </h2>
            <div className="space-y-3">
              {problems.map((problem, index) => (
                <div key={index} className="flex items-start gap-3 text-left">
                  <XCircle className="h-5 w-5 text-brand-azul/40 flex-shrink-0 mt-1" />
                  <p className="text-brand-azul/70 leading-relaxed">{problem}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6 rounded-3xl bg-muted/50 p-8 border border-border">
            <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider">
              Com a dgenny
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul leading-tight">
              A operação vira escolha. Não acaso.
            </h2>
            <div className="space-y-3">
              {solutions.map((solution, index) => (
                <div key={index} className="flex items-start gap-3 text-left">
                  <CheckCircle2 className="h-5 w-5 text-brand-roxo flex-shrink-0 mt-1" />
                  <p className="text-brand-azul font-medium leading-relaxed">{solution}</p>
                </div>
              ))}
            </div>
            <div className="pt-2">
              <div className="bg-brand-rosa/40 p-4 rounded-xl border border-brand-rosa/60">
                <p className="text-brand-azul font-semibold">
                  Seu time foca em decisão. A dgenny cuida da execução.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
